// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3.label[data-v-4ce186cf]{font-family:Circular Std;font-style:normal;font-weight:700;font-size:26px;line-height:33px;letter-spacing:-.01em;color:#000;padding:0!important}@media screen and (max-width:767px){h3[data-v-4ce186cf]{font-size:21px!important}}", ""]);
// Exports
module.exports = exports;
